import { render } from "./OdStatusBadge.vue?vue&type=template&id=4050f1e8"
import script from "./OdStatusBadge.vue?vue&type=script&lang=js"
export * from "./OdStatusBadge.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__